export default class StageTypeDomainService {
    static get NONE_ID() {
        return 3;
    }
    static get ENDING_SUCCESS_ID() {
        return 2;
    }
    static get ENDING_FAILURE_ID() {
        return 1;
    }
    static get ENDING_SUCCESS_DESCRIPTION() {
        return "This is an ending success stage.  Opportunities in this stage are considered to have finished the pipeline.";
    }
    static get ENDING_FAILURE_DESCRIPTION() {
        return "This is a ending failure stage. Opportunities in this stage are considered to have finished the pipeline.";
    }
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
